<template>
	<div class="content">
		<div class="section">
			<el-input :placeholder="$t('logistics.logistics2')" v-model="expressNo" @keyup.enter.native="queryExpress"> </el-input>
			<div class="margin-top-20 text-right">
				<span class="btn-theme-green cursor-pointer" @click="queryExpress()">{{ $t('logistics.logistics3') }}</span>
			</div>
		</div>
		<div class="section margin-top-50" v-if="expressInfoShow">
			<table class="table-content">
				<thead>
					<tr>
						<th width="250"></th>
						<th width="550"></th>
						<th width="400"></th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td class="td-bg">{{ $t('logistics.logistics8') }}</td>
						<td>{{ logisticsInfo.trackingNumber }}</td>
            <td>
              <span v-if="logisticsInfo.transBillid != null && logisticsInfo.transBillid != ''">他社送り状番号 </span> <a :href="'http://k2k.sagawa-exp.co.jp/p/web/okurijosearch.do?okurijoNo=' + logisticsInfo.transBillid" target="_blank">{{logisticsInfo.transBillid}}</a>
            </td>
					</tr>
					<tr>
						<td class="td-bg">{{ $t('logistics.logistics6') }}</td>
						<td class="td-bg" colspan="2">
							<span class="btn-theme-green">{{ deliveryStatus }}</span>
						</td>
					</tr>
					<tr v-if="logisticsInfo.endFlag == 1">
						<td class="td-bg">{{ $t('logistics.logistics4') }}</td>
						<td colspan="2">
							<div>{{ $t('logistics.logistics16') }}</div>
							<div>
								{{ $t('logistics.logistics7') }}：<span class="text-theme-greem">{{ logisticsInfo.receiveDate }}</span>
							</div>
						</td>
					</tr>

					<tr>
						<td class="td-bg">{{ $t('logistics.logistics9') }}</td>
						<td colspan="2">{{ logisticsInfo.sendDate }}</td>
					</tr>
					<tr>
						<td class="td-bg">{{ $t('logistics.logistics10') }}</td>
						<td colspan="2">{{ logisticsInfo.sendLocation }}</td>
					</tr>
					<tr>
						<td class="td-bg">{{ $t('logistics.logistics11') }}</td>
						<td colspan="2">{{ logisticsInfo.receiveLocation }}</td>
					</tr>
					<!-- <tr>
            <td class="td- bg">{{ $t("logistics.logistics12") }}</td>
            <td colspan="2"></td>
          </tr> -->
					<tr>
						<td class="td-bg">{{ $t('logistics.logistics13') }}</td>
						<td class="td-bg">{{ $t('logistics.logistics14') }}</td>
						<td class="td-bg">{{ $t('logistics.logistics15') }}</td>
					</tr>
					<tr v-for="(item, index) in logisticsInfo.trackingInfoList" :key="index">
						<td>{{ item.trackingDetail }}</td>
						<td>{{ item.checkpointDate }}</td>
						<td v-html="item.location">{{ item.location }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
import { messages } from '@/i18n';

export default {
	data() {
		return {
			i18nMessages: messages,
			expressInfoShow: false, // 物流详情隐藏
			expressNo: '',
			logisticsInfo: {}, // 物流信息
			deliveryStatus: '' // 配送状态
		};
	},
	methods: {
		// 查询快递
		async queryExpress() {
			let expressNum = this.expressNo.trim();
			if (expressNum) {
				// console.log(this.expressNo);

				const { data: res } = await this.$http.get('/queryLogisticsInfo/' + expressNum + '');
				if (res.code == '200') {
					this.logisticsInfo = res.data;
					this.deliveryStatus = res.data.trackingInfoList[0].trackingDetail;
					this.expressInfoShow = true;
				} else if (res.code == '500') {
					this.expressInfoShow = false;
					this.$message({
						message: this.$t('logistics.logistics17'),
						type: 'error'
					});
				} else {
					this.expressInfoShow = false;
					this.$message({
						message: res.message,
						type: 'error'
					});
				}
			} else {
				this.$message({
					message: this.$t('logistics.logistics2'),
					type: 'error'
				});
				return;
			}
		}
	}
};
</script>

<style lang="less" scoped>
.content {
	width: 100%;
	height: 100%;
	background-image: url('../assets/images/logistics_bg.jpg');
	background-repeat: no-repeat;
	background-size: 100% 100%;
	overflow: auto;
	padding-top: 66px;
	padding-bottom: 60px;
}
.section {
	max-width: 1200px;
	margin: auto;
}
.margin-top-20 {
	margin-top: 20px;
}
.margin-top-50 {
	margin-top: 50px;
}
.text-right {
	text-align: right;
}
.cursor-pointer {
	cursor: pointer;
}

.text-theme-greem {
	color: #2e85a1;
	font-size: 18px;
}
.btn-theme-green {
	display: inline-block;
	background-color: #2e85a1;
	border-radius: 4px;
	padding: 7px 23px;
	color: #ffffff;
}
.table-content {
	width: 100%;
	height: auto;
	border-collapse: collapse;
	thead {
		background-color: #3a4255;
		color: #ffffff;
		text-align: left;
	}
	tbody {
		background-color: #ffffff;
		tr {
			td {
				font-size: 14px;
				color: #3a4255;
				padding: 12px 20px;
				border: 1px solid #e5e5eb;
			}
			.td-bg {
				background-color: #f5f6f8;
			}
		}
	}
}
</style>
